import { render, staticRenderFns } from "./item_tpl.vue?vue&type=template&id=13fbb4fe&"
import script from "./item_tpl.vue?vue&type=script&lang=js&"
export * from "./item_tpl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports